import React from 'react';
import configJSON from 'config.json';
import HeadData from 'components/head-data';
import NewHomes from 'components/pages/newhomes';
import Layout from 'components/layout';
import endpoint from 'utils/endpoint';
import { HttpRequestMethodTypes } from 'types/HttpRequestMethodTypes';
import { createGetServerSideProps } from 'utils/next/shared-getServerSideProps';
import { NOT_FOUND } from 'constants/not-found';
import { isZoocasaTenant } from '@tenants/utils/which-tenant';
import { NEWHOMES_ROUTE } from 'components/dynamic-page/route-matchers';

import type { PreConstructionProject, GetProjectsResponse } from '@zoocasa/pre-construction';
import type { HandlerType } from 'utils/next/shared-getServerSideProps';
import type { FeaturesType } from 'contexts/features';
import type { TenantTypes } from '@tenants/manager';

const getServerSidePropsHandler: HandlerType<Props> = async (_context, features?: FeaturesType, tenant?: TenantTypes) => {
  // Only allow access to this page on the Zoocasa tenant
  if (!isZoocasaTenant(tenant.id, features)) {
    return NOT_FOUND;
  }

  const { vip, available, upcoming }: GetProjectsResponse = await endpoint('/services/pre-construction/v1/projects', HttpRequestMethodTypes.GET, undefined, undefined, undefined, configJSON.preconHost);

  return {
    props: {
      props: {
        vip: vip ? vip : [],
        available: available ? available : [],
        upcoming: upcoming ? upcoming : [],
      },
    },
  };
};

export const getServerSideProps = createGetServerSideProps<Props>(getServerSidePropsHandler);

interface Props {
  props: {
    vip: PreConstructionProject[];
    available: PreConstructionProject[];
    upcoming: PreConstructionProject[];
  };
}

export default function PreCon({ props }: Props) {
  const { vip, available, upcoming } = props;
  const headerData = {
    title: 'Toronto New Homes: Developments and New Construction | Zoocasa',
    metaDescription: 'Zoocasa provides all new pre-construction developments for new residential homes, condos, townhouses, and new real estate. Toronto and more.',
  };

  return (
    <Layout routeName={NEWHOMES_ROUTE}>
      <HeadData data={headerData} />
      <NewHomes vip={vip} available={available} upcoming={upcoming} />
    </Layout>
  );
}
